import React, { useCallback, useEffect, useState } from 'react';
import { Row, Col } from 'react-bootstrap';
import { toast } from 'react-toastify';
import {
  InputAsyncSelect,
  InputMoney,
  InputNumber,
  InputSelect,
} from '~/components/NovosInputs';
import Separator from '~/components/Separator';
import ToggleDefault from '~/components/ToggleDefault';
import { useEmissaoNFE } from '~/pages/EmissaoNFE/EmissaoNFEContext';
import { CalculosDaTabelaManual } from '~/pages/EmissaoNFE/functions/Calculos';
import {
  formatCurrencyBR,
  moneyFormat,
  toNumberOrZero,
} from '~/utils/functions';
import { Container, EntradaItensContainer } from './styles';
import { ListaDeCFOP, Produto } from '../../../../protocols';

import Swal from 'sweetalert2';
import withReactContent from 'sweetalert2-react-content';

import itensNfe from '../../../../defaultData/itens.json';
import { DefineCFOP } from '~/pages/EmissaoNFE/functions/Auxiliares';
import { SelectType } from '~/components/NovosInputs/InputSelect/protocols';
import { insertOrUpdate } from '~/utils/masterDetail';
import { nanoid } from 'nanoid';
import { InputIbsCbs } from '~/components/NovosInputs/InputIbsCbs';
import { CustomButtonNovo } from '~/components/Buttons/CustomButtonNovo';
import { aplicarIbsCbsOuPadrao } from '~/components/NovosInputs/InputIbsCbs/functions/aplicarIbsCbsOuPadrao';
import { alimentaDadosIBSCBSCliente } from '~/components/NovosInputs/InputIbsCbs/functions/alimentaDadosIBSCBSCliente';

const MySwal = withReactContent(Swal);

export const FormItens: React.FC = () => {
  const {
    codLoja,
    loja,
    isBonificado,
    setIsBonificado,
    produtos,
    setProdutos,
    isUpdate,
    formNFE: { getValues: getFormNFEValues },
    formItens: {
      register,
      handleSubmit,
      control,
      setFocus,
      setValue,
      getValues,
      clearErrors,
      formState,
      watch,
      reset,
    },
    formDadosEntrega: {
      getValues: getValuesDadosEntrega,
      setError: setErrorDadosEntrega,
    },
    isFormItendEditing,
    produtoSelecionado,
    setProdutoSelecionado,
    setIsFormItendEditing,
    listaDeCfop,
    masterDetail,
    setMasterDetail,
    setLocalConsumoDesabilitado,
    parceiro,
    setCurrentTab,
    setCodIbsCbsRetriever,
    codIbsCbsRetriever,
  } = useEmissaoNFE();

  const [adding, setAdding] = useState(false);
  const [selecting, setSelecting] = useState(false);

  const [qtd_entrada, val_tabela, desconto, acrescimo] = watch([
    'qtd_entrada',
    'val_tabela',
    'desconto',
    'acrescimo',
  ]);
  const [subTotal, setSubTotal] = useState('0');
  const [subTotalIsNegative, setSubTotalIsNegative] = useState(false);
  const [cfopOptions, setCfopOptions] = useState<SelectType[]>([]);

  useEffect(() => {
    const formatedQtdEmbalagemVenda = qtd_entrada || 0;
    let formatedValorUnitario = val_tabela || 0;
    let formatedAcrescimo = acrescimo || 0;
    let formatedDesconto = desconto || 0;

    if (val_tabela && val_tabela !== '') {
      formatedValorUnitario = Number(
        String(val_tabela).replace('.', '').replace(',', '.'),
      );
    }
    if (acrescimo && acrescimo !== '') {
      formatedAcrescimo = Number(
        String(acrescimo).replace('.', '').replace(',', '.'),
      );
    }
    if (desconto && desconto !== '') {
      formatedDesconto = Number(
        String(desconto).replace('.', '').replace(',', '.'),
      );
    }

    // const mult = formatedQtdEmbalagemVenda * formatedValorUnitario;
    // const sub = formatedAcrescimo - formatedDesconto;
    // const subTotalCalculado = mult + sub;
    const subTotalCalculado =
      formatedQtdEmbalagemVenda *
      (formatedValorUnitario - formatedDesconto + formatedAcrescimo);

    if (typeof subTotalCalculado === 'number') {
      const novoSubTotal = moneyFormat(String(subTotalCalculado), 2);
      setSubTotal(novoSubTotal);
      setValue('subtotal', novoSubTotal);

      if (subTotalCalculado < 0) {
        setSubTotalIsNegative(true);
        return;
      }
      setSubTotalIsNegative(false);
    }
  }, [acrescimo, desconto, qtd_entrada, setValue, val_tabela]);

  const handleLimpar = useCallback(() => {
    reset(itensNfe);
    setIsBonificado(false);
    setProdutoSelecionado({} as Produto);
    setIsFormItendEditing(false);
    FocusFilter('produto');
    setTimeout(() => {
      setCodIbsCbsRetriever(null);
      setValue('cod_ibs_cbs', { value: undefined, label: undefined });
    }, 100);
  }, [
    reset,
    setIsBonificado,
    setIsFormItendEditing,
    setProdutoSelecionado,
    setValue,
  ]);

  const obterLocalConsumoIndex = (): number => {
    const rawLocalConsumo = getFormNFEValues('tipo_local_consumo')?.value;
    const parsed =
      typeof rawLocalConsumo === 'string'
        ? Number(rawLocalConsumo)
        : (rawLocalConsumo as number | undefined);
    return Number.isFinite(parsed) ? (parsed as number) : 0;
  };

  async function FocusFilter(id: string) {
    const input = await document.getElementById(id);
    input?.focus();
  }
  const handleAddProduto = handleSubmit(async (data) => {
    try {
      const { flg_orgao_publico } = getFormNFEValues('busca_parceiro');
      const item: any = getValues('busca_produto');

      if (
        item.flg_ipv === false &&
        !Number.isInteger(Number(data.qtd_entrada))
      ) {
        toast.warn('Quantidade Total não pode ser fracionada.');
        return;
      }

      setSelecting(true);

      const formatedItem = await CalculosDaTabelaManual({
        item,
        qtd_entrada: data.qtd_entrada,
        val_tabela_str: data.val_tabela,
        val_desconto_str: data.desconto,
        val_acrescimo_str: data.acrescimo,
        flg_orgao_publico,
        tipo_tributacao: getValues('tributacao')?.tipo_tributacao,
        tribData: getValues('tributacao'),
        cod_situacao_tributaria:
          getValues('tributacao')?.cod_situacao_tributaria,
        cod_tributacao: getValues('tributacao')?.value,
        val_reducao_base_calculo: getValues('tributacao')?.val_reducao,
        per_icms: getValues('tributacao')?.val_icms,
        tipo_regime: loja.tipo_regime,
        des_sigla: loja.uf,
        cfop: getValues('cfop')?.cfop,
        des_cfop: getValues('cfop')?.des_cfop,
        cfopData: getValues('cfop'),
        bonificado: isBonificado,
        lastIndex: produtos.length,
        produtoSelecionado,
      });
      formatedItem.uuid = isFormItendEditing.isEdit
        ? isFormItendEditing.uuid
        : nanoid();

      const rawCidadeEntrega =
        getValuesDadosEntrega('cod_cidade_entrega')?.value ?? null;

      const ibscbs = await alimentaDadosIBSCBSCliente({
        itensParaProcessar: formatedItem,
        codIbsCbsInput: getValues('cod_ibs_cbs')?.value,
        ctx: {
          cbxLocalConsumoIndex: obterLocalConsumoIndex(),
          loja: { codCidade: loja.cod_cidade, estado: loja.uf },
          empresa: loja.empresa,
          cliCidadeCodCidade: rawCidadeEntrega,
          cliMestreCodCidade: parceiro.cod_cidade,
        },
        isItemEditing: isFormItendEditing?.isEdit,
      });

      /**
       * No caso de inserção de um item que já existe na tabela
       */
      const produtoExists = produtos.find(
        (produto) =>
          produto.cod_produto === formatedItem.cod_produto &&
          produto.flg_bonificado === formatedItem.flg_bonificado &&
          produto.uuid !== isFormItendEditing.uuid,
      );
      if (produtoExists) {
        const confirmaSubstituicao = await MySwal.fire({
          title: 'Item já existente na tabela',
          text: 'Deseja substituir?',
          showCancelButton: true,
          confirmButtonColor: '#8850BF',
          cancelButtonColor: '#DE350B',
          confirmButtonText: 'Sim',
          cancelButtonText: 'Não',
        }).then((result) => {
          if (result.isConfirmed) {
            return true;
          }
          return false;
        });
        if (confirmaSubstituicao) {
          formatedItem.uuid = produtoExists.uuid;
          const produtosDetail: any[] = await insertOrUpdate(
            'produtos',
            formatedItem,
            masterDetail,
            setMasterDetail,
          );
          setProdutos(produtosDetail);
        }
        handleLimpar();
        return;
      }

      /**
       * Caso não esteja editando o item e ele ainda não exista na tabela
       */
      if (produtos.length + 1 > 500) {
        toast.warning('Limite de 500 items excedido.');
        return;
      }

      ibscbs.val_red_social = formatCurrencyBR(ibscbs.val_red_social);
      ibscbs.per_aliq_ibs_est = moneyFormat(String(ibscbs.per_aliq_ibs_est));
      ibscbs.val_bc_ibs_cbs = moneyFormat(
        toNumberOrZero(ibscbs.val_bc_ibs_cbs).toFixed(2),
      );
      ibscbs.val_cbs = formatCurrencyBR(ibscbs.val_cbs?.toFixed(2));
      ibscbs.val_ibs_est = formatCurrencyBR(ibscbs.val_ibs_est);
      ibscbs.val_ibs_mun = moneyFormat(String(ibscbs.val_ibs_mun));
      ibscbs.per_red_ibs = moneyFormat(String(ibscbs.per_red_ibs));
      ibscbs.per_aliq_cbs = moneyFormat(String(ibscbs.per_aliq_cbs));
      ibscbs.per_red_cbs = moneyFormat(String(ibscbs.per_red_cbs));
      ibscbs.per_aliq_ibs_mun = moneyFormat(String(ibscbs.per_aliq_ibs_mun));

      const produtosDetail: any[] = await insertOrUpdate(
        'produtos',
        ibscbs,
        masterDetail,
        setMasterDetail,
      );
      setProdutos(produtosDetail);
      handleLimpar();
      setLocalConsumoDesabilitado(true);
    } finally {
      setSelecting(false);
    }
  });

  const handleSelectedProduct = useCallback(
    async (selected: any) => {
      try {
        const perfil = getFormNFEValues('cod_perfil')?.value;
        if (perfil === undefined) {
          toast.warning('Perfil deve ser informado.');
          return;
        }

        const localConsumo = getFormNFEValues('tipo_local_consumo');
        // LOCAL CONSUMO: OUTROS
        if (
          toNumberOrZero(localConsumo?.value) === 2 &&
          !getValuesDadosEntrega('cod_cidade_entrega')?.value
        ) {
          toast.warning(
            'Dados do local de consumo deve ser informada nos dados de entrega.',
            { toastId: 'toast:localConsumoSemCidade2' },
          );
          setErrorDadosEntrega('cod_cidade_entrega', { type: 'required' });
          setCurrentTab('dados-entrega');
          return;
        }

        setAdding(true);

        /** Definine o CFOP */
        const cfop: any = DefineCFOP(
          listaDeCfop,
          selected.tipo_tributacao,
          true,
          loja?.uf === getFormNFEValues('busca_parceiro')?.des_uf,
          selected,
        );
        if (typeof cfop === 'object') {
          setValue('cfop', {
            value: cfop.value,
            label: cfop.label,
            ...cfop,
          });
        }
        const selectedAny: any = selected;
        const tributacaoValue = selectedAny.cod_trib_entrada
          ? {
              value: selectedAny.cod_trib_entrada,
              label: `${selectedAny.cod_trib_entrada} - ${selectedAny.des_tributacao}`,
              cod_tributacao: selectedAny.cod_trib_entrada,
              des_tributacao: selectedAny.des_tributacao,
              val_icms: selectedAny.val_icms,
              val_reducao: selectedAny.val_reducao,
              tipo_tributacao: selectedAny.tipo_tributacao,
              cod_bc_mr: selectedAny.cod_bc_mr,
              cod_situacao_tributaria: selectedAny.cod_situacao_tributaria,
              cod_tributacao_pdv: selectedAny.des_tributcod_tributacao_pdvacao,
            }
          : { value: null, label: 'Selecione...' };

        clearErrors('busca_produto');
        setValue('busca_produto', selected);
        setValue('tributacao', tributacaoValue);
        setFocus('qtd_entrada');
        if (selected.val_preco)
          setValue('val_tabela', moneyFormat(selected.val_preco, 2));

        const ibscbs = await aplicarIbsCbsOuPadrao(selected?.cod_ibs_cbs);
        setCodIbsCbsRetriever(ibscbs);
      } finally {
        setAdding(false);
      }
    },
    [
      clearErrors,
      getFormNFEValues,
      getValuesDadosEntrega,
      listaDeCfop,
      loja?.uf,
      setCurrentTab,
      setErrorDadosEntrega,
      setFocus,
      setValue,
      setCodIbsCbsRetriever,
    ],
  );

  useEffect(() => {
    const options = listaDeCfop.map((cfop: ListaDeCFOP) => ({
      label: cfop.cfop,
      value: cfop.des_cfop,
      ...cfop,
    }));
    setCfopOptions(options);
  }, [listaDeCfop]);

  return (
    <Container>
      <Separator labelText="Itens da NF *" sidePadding="0 0" />
      <Row>
        <Col sm={12} md={10}>
          <InputAsyncSelect
            label="Busca Produto"
            maxLength={50}
            placeholder="Selecione..."
            name="busca_produto"
            onBlur={() => {
              const v = getValues('busca_produto');
              if (typeof v === 'undefined') clearErrors('busca_produto');
            }}
            id="produto"
            register={register}
            isError={!!formState.errors.busca_produto}
            control={control}
            disabled={isUpdate || isFormItendEditing.isEdit}
            changeSelected={async (selected) => {
              await handleSelectedProduct(selected);
              clearErrors();
            }}
            api={{
              route: '/emissao-nfe/produtos',
              method: 'get',
              bodyParams: {
                loja: codLoja,
              },
              fields: ['cod_produto', 'des_produto'],
              dependsOf: ['loja'],
              messageForDependsOf:
                'É necessário selecionar a loja na capa da NF',
            }}
          />
        </Col>
        <Col sm={12} md={2}>
          <CustomButtonNovo
            onClick={handleLimpar}
            style={{ marginTop: '28px' }}
            disabled={isUpdate || adding || selecting}
            variant="clear"
            label="Limpar"
            width="100%"
          />
        </Col>
        <Col sm={12} md={3}>
          <InputAsyncSelect
            label="Tributação"
            maxLength={50}
            placeholder="Selecione..."
            name="tributacao"
            register={register}
            isError={!!formState.errors.tributacao}
            control={control}
            disabled={isUpdate}
            changeSelected={(selected) => {
              clearErrors('tributacao');
              setValue('tributacao', selected);
            }}
            api={{
              route: '/emissao-nfe/tributacao',
              method: 'get',
              fields: ['cod_tributacao', 'des_tributacao'],
              searchBeforeFilter: true,
            }}
          />
        </Col>
        <Col sm={12} md={4}>
          <InputSelect
            label="CFOP"
            maxLength={50}
            placeholder="Selecione..."
            name="cfop"
            register={register}
            isError={!!formState.errors.cfop}
            control={control}
            disabled={isUpdate}
            options={cfopOptions}
            changeSelected={(selected) => {
              clearErrors('cfop');
              setValue('cfop', selected);
            }}
          />
        </Col>
        <Col sm={12} md={3}>
          <InputIbsCbs
            label="IBS/CBS"
            name="cod_ibs_cbs"
            register={register}
            control={control}
            isError={false}
            changeSelected={(selected) => {
              clearErrors('cod_ibs_cbs');
              setValue('cod_ibs_cbs', selected);
            }}
            valueRetriever={codIbsCbsRetriever}
            disabled={isUpdate}
            reset={typeof codIbsCbsRetriever !== 'number'}
          />
        </Col>
        <Col sm={12} md={2}>
          <div
            style={{
              marginTop: '35px',
            }}
          >
            <ToggleDefault
              labelText="Bonificado?"
              setChecked={isBonificado}
              inLine
              disabled={!getValues('cfop')?.value || isUpdate}
              onSwitch={() => {
                if (getValues('cfop')?.value.slice(-3) !== '910') {
                  toast.warning('Código Fiscal deve ser de bonificação.');
                  return;
                }
                setValue('bonificado', !isBonificado);
                setIsBonificado(!isBonificado);
              }}
            />
          </div>
        </Col>
      </Row>
      <Row className="mt-4">
        <Col sm={12} md={4}>
          <EntradaItensContainer>
            <Row className="bg-green">
              <Col sm={12} md={6}>
                <InputNumber
                  label="Quantidade"
                  max={10000}
                  maxLength={50}
                  placeholder="0"
                  name="qtd_entrada"
                  register={register}
                  disabled={isUpdate}
                  isError={!!formState.errors.qtd_entrada}
                  onKeyPress={(event) => {
                    if (event.key === 'Enter') {
                      handleAddProduto();
                      clearErrors();
                    }
                  }}
                />
              </Col>
              <Col sm={12} md={6}>
                <InputMoney
                  label="Valor Unitário"
                  placeholder="0,00"
                  min={0}
                  decimals={2}
                  maxLength={14}
                  name="val_tabela"
                  register={register}
                  control={control}
                  disabled={isUpdate}
                  isError={!!formState.errors.val_tabela}
                  showIcon={false}
                  onKeyPress={(event) => {
                    if (event.key === 'Enter') {
                      handleAddProduto();
                      clearErrors();
                    }
                  }}
                />
              </Col>
            </Row>
          </EntradaItensContainer>
        </Col>
        <Col sm={12} md={2}>
          <InputMoney
            label="Desconto"
            placeholder="0,00"
            min={0}
            decimals={2}
            maxLength={14}
            name="desconto"
            register={register}
            control={control}
            disabled={isUpdate}
            isError={!!formState.errors.desconto}
            showIcon={false}
          />
        </Col>
        <Col sm={12} md={2}>
          <InputMoney
            label="Acréscimo"
            placeholder="0,00"
            min={0}
            decimals={2}
            maxLength={14}
            name="acrescimo"
            register={register}
            control={control}
            disabled={isUpdate}
            isError={!!formState.errors.acrescimo}
            showIcon={false}
          />
        </Col>
        <Col
          sm={12}
          md={2}
          className={`sub-total ${subTotalIsNegative ? 'negative' : ''}`}
        >
          <span
            title={`${subTotalIsNegative ? 'SubTotal deve ser positivo' : ''}`}
          >
            SubTotal: {subTotal}
          </span>
        </Col>
        <Col sm={12} md={2} className="d-flex justify-content-end add">
          <CustomButtonNovo
            variant="confirm"
            className="mt-auto mb-2 w-100"
            onClick={async () => {
              await handleAddProduto();
            }}
            disabled={isUpdate || adding || selecting}
            showLoading={selecting}
            label="Adicionar"
          />
        </Col>
      </Row>
    </Container>
  );
};
